import { render, staticRenderFns } from "./InformarProblema.vue?vue&type=template&id=3426398e&"
import script from "./InformarProblema.vue?vue&type=script&lang=js&"
export * from "./InformarProblema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports